<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    loading?: boolean;
    disabled?: boolean;
    type?: "button" | "submit" | "reset";
    size?: "x-small" | "small" | "default" | "large" | "x-large";
  }>(),
  {
    loading: false,
    disabled: false,
    type: "button",
    size: "default",
  }
);

const emit = defineEmits<{ click: [event: MouseEvent] }>();
</script>

<template>
  <v-btn
    :type="props.type"
    :loading="props.loading"
    :disabled="props.disabled"
    :size="props.size"
    variant="flat"
    class="orbis-btn tertiary-button"
    @click="emit('click', $event)"
  >
    <slot />
  </v-btn>
</template>

<style scoped>
/* Palette + weight only — height comes from Vuetify's `size` prop; horizontal
   padding (`--btn-px`) + font-size (`--btn-fs`) scale with it (motion lives in
   the shared `.orbis-btn` class in style.css). Smaller radius + tighter content
   gap are set as local custom props so the shared rule picks them up without a
   specificity fight. */
.tertiary-button {
  --btn-radius: 10px;
  --btn-gap: 6px;

  padding: 0 var(--btn-px, 13px) !important;

  border: 1px dashed var(--btn-hairline) !important;
  border-radius: var(--btn-radius) !important;

  background: var(--btn-surface) !important;

  font-size: var(--btn-fs);
  font-weight: 620;
  white-space: nowrap;

  box-shadow: var(--btn-shadow);
}

.tertiary-button {
  color: var(--btn-ink-muted) !important;
}

.tertiary-button:hover:not(:disabled) {
  color: var(--btn-ink) !important;
  border-color: var(--btn-hairline-strong) !important;
}
</style>
